import { render, staticRenderFns } from "./select5.vue?vue&type=template&id=36f038b3&"
import script from "./select5.vue?vue&type=script&lang=js&"
export * from "./select5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports